"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CharactersView;
var jsx_runtime_1 = require("react/jsx-runtime");
var EditCharacterForm_1 = __importDefault(require("@components/Forms/CharacterForm/EditCharacterForm"));
var NewCharacterForm_1 = __importDefault(require("@components/Forms/CharacterForm/NewCharacterForm"));
var CharactersTable_1 = __importDefault(require("@components/Tables/Characters/CharactersTable"));
var react_router_dom_1 = require("react-router-dom");
function CharactersView() {
    return ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "new", element: (0, jsx_runtime_1.jsx)(NewCharacterForm_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: ":characterId", element: (0, jsx_runtime_1.jsx)(EditCharacterForm_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/", element: (0, jsx_runtime_1.jsx)(CharactersTable_1.default, {}) })] }));
}
